import styled from "styled-components";
import media from "styled-media-query";
import { rem } from "polished";

import { themes } from "styles";

export const Container = styled.div`
  margin-bottom: 10px;

  ${media.greaterThan("large")`
    margin-bottom: 30px;
  `}
`;

export const Title = styled.h1``;

export const Description = styled.p`
  padding-top: 12px;

  line-height: 160%;
  font-size: ${rem("11px")};
  color: ${themes.text.high};

  ${media.greaterThan("large")`
    font-size: ${rem("12px")};
  `}

  ${media.greaterThan("huge")`
    font-size: ${rem("15px")};
  `}
`;
